import React from 'react';

const Avatarcircle = ({children}) => {
    return (
        <div className="iconbar-vivirseguro">{children}</div>
    );
}

export {Avatarcircle} ;